import { Action, createReducer, on } from '@ngrx/store';
import { toggleLockAction } from 'src/app/actions/app';

export interface IAppState {
  isLocked: boolean;
}

export const initialState: IAppState = {
  isLocked: false
};

const _AppReducer = createReducer(
  initialState,
  on(toggleLockAction, state => ({
    ...state,
    isLocked: !state?.isLocked
  }))
);

export function appReducer(state: IAppState | undefined, action: Action) {
  return _AppReducer(state, action);
}
